import React, { useEffect, useState } from 'react';
import { auth } from '../../firebaseConfig';
import {
  reauthenticateWithCredential,
  EmailAuthProvider,
  updatePassword,
} from 'firebase/auth';
import { Eye, EyeSlash } from 'react-bootstrap-icons';
import './index.css';

const ChangePassword = () => {
  const [email, setEmail] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [changeError, setChangeError] = useState('');
  const [changeSuccess, setChangeSuccess] = useState('');

  // Fetch current user's email on load
  useEffect(() => {
    const user = auth.currentUser;
    if (user && user.email) {
      setEmail(user.email);
    }
  }, []);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setChangeError('');
    setChangeSuccess('');

    try {
      const user = auth.currentUser;
      if (!user) {
        throw new Error('No user is currently signed in.');
      }

      const credential = EmailAuthProvider.credential(email, currentPassword);
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPassword);

      setChangeSuccess('Password updated successfully!');
      setCurrentPassword('');
      setNewPassword('');
    } catch (error) {
      let errorMessage = 'Failed to change password. Please try again.';
      if (error.code === 'auth/wrong-password') {
        errorMessage = 'Current password is incorrect.';
      } else if (error.code === 'auth/invalid-email') {
        errorMessage = 'Invalid email address.';
      } else if (error.code === 'auth/user-mismatch') {
        errorMessage = 'Email does not match the current user.';
      } else if (error.code === 'auth/weak-password') {
        errorMessage = 'New password is too weak. Use at least 6 characters.';
      }
      setChangeError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="owner-login-container">
      <div className="owner-login-card">
        <h2>Change Password</h2>

        {changeSuccess && <div className="success-message">{changeSuccess}</div>}
        {changeError && <div className="error-message">{changeError}</div>}

        <form onSubmit={handleChangePassword}>
          <div className="form-group">
            <label htmlFor="changeEmail">Email Address</label>
            <input
              type="email"
              id="changeEmail"
              value={email}
              disabled
              readOnly
            />
          </div>

          <div className="form-group password-group">
            <label htmlFor="currentPassword">Current Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              placeholder="Enter current password"
            />
            <span
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeSlash /> : <Eye />}
            </span>
          </div>

          <div className="form-group password-group">
            <label htmlFor="newPassword">New Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              placeholder="Enter new password"
            />
            <span
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeSlash /> : <Eye />}
            </span>
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? <span className="spinner"></span> : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
